import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useMicrosite } from '../../custom-hooks/useMicrosite';
import { withMicroSites } from '../../hoc/withMicroSites';
import { useParams } from 'react-router-dom';
import MicroSiteAccordian from '../microsite-accordian';
import NewEditMicrosite from './edit/NewEditMicrosite';
import { getRequest } from '../../api/http';
import userServiceApi from '../../api/userServiceApi';
import { toast } from 'react-toastify';



function MicroSites({ micrositeData }) {
    const { getMicroSites } = useMicrosite();
    const { micrositeId } = useParams();

    const [didProSettingsUpdate, setDidProSettingsUpdate] = useState(false)
    const [newProSettings, setNewProSettings] = useState([])
    const [loadingProSettings,setLoadingProSettings] = useState(false)
    useEffect(() => {
        getMicroSites();
    }, [])


    useEffect(() => {
        if(!micrositeId) {
            return
        }
        setNewProSettings(() => [])
        const getProSettings = async () => {
            try {
                
                const response = await getRequest(userServiceApi.getMicroSiteTabConfig(micrositeId))
                if (response?.data) {
                    
                    setNewProSettings(() => [...response?.data])
                }
            } catch (error) {
                toast.error("Failed to fetch pro settings")
            }
            finally{
                setLoadingProSettings(false)
            }
        }

        setLoadingProSettings(true)
        const FetchProSettingsDelay = setTimeout(() => {
            getProSettings();
        }, 300)

        return (() => { clearTimeout(FetchProSettingsDelay) })

    }, [didProSettingsUpdate, micrositeId])

    return (
        <div direction="vertical" style={{ width: '100%' }}>
            {
                micrositeData.map(microSite => {
                    return <MicroSiteAccordian key={microSite.id} data={microSite} activeKey={micrositeId} micrositeData={micrositeData} setDidProSettingsUpdate={setDidProSettingsUpdate}>
                        {newProSettings && !!newProSettings?.length && <NewEditMicrosite micrositeId={micrositeId} newProSettings={newProSettings} />}
                        {loadingProSettings && <div style={{
                            marginTop:'3rem',
                            display:'flex',
                            justifyContent: 'center',
                        }}>
                            <Spin className='' tip="Loading" size='large' />
                            </div>}
                    </MicroSiteAccordian>
                })
            }

        </div>
    )
}


export default withMicroSites(React.memo(MicroSites))